export const componentIds = {
  Collapsible: 'Collapsible',
  CollapsibleBody: 'CollapsibleBody',
  CollapsibleButton: 'CollapsibleButton',
  CollapsibleLink: 'CollapsibleLink',
};
